import React from 'react';

export const getFieldErrors = (field, errors) => (errors && errors?.[field]) ? <span className='error'>{errors[field].join(', ')}</span> : undefined
export const getFieldStatus = (field, errors) => (errors && errors?.[field]) ? "error" : undefined